import { proNavigator } from "single-spa/react-app/ProNavigator";

export const isPeriodOverPeriodToggleSupported = () => {
    const state = proNavigator.current();
    const { periodOverPeriodEnabled } = state;
    return periodOverPeriodEnabled;
};
